<template>
  <div class="card flex items-center mb-5 space-x-5">
    <div
      v-if="showTreeIcon"
      class="w-14"
    >
      <img
        src="/img/icons/svg/pine tree.svg"
        alt="Windmill"
        class="w-full"
      >
    </div>
    <div>
      <h2 class="text-primary-700 mb-0.5 text-lg font-bold">
        Next Tree
      </h2>
      <div class="mb-2 text-2xl font-semibold">
        <span class="text-red-600">{{ milestones.target_tree - milestones.next_tree }}</span>
        <span class="text-gray-300"> / </span>
        <span class="text-green-600">{{ milestones.target_tree }}</span>
      </div>
      <p class="mb-2 leading-tight text-gray-500">
        Points remaining to plant your next tree.
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "v-milestones-nex-tree",
  props: {
    milestones: {
      type: Object,
      required: true
    },
    showTreeIcon: {
      type: Boolean,
      default: true
    }
  }
};
</script>
